import {useHistory, useParams} from "react-router-dom";
import {DashboardLayout} from "components/Layout";
import {SubmitButton} from "components/Button";
import {CircleLoader} from "components/Loader";
import {FormCard} from "components/Form";
import {useDetailKonsultasi} from "hooks/SuperAdmin/Konsultasi";

export function MasterKonsultasiDetailPage() {
	const history = useHistory();
	const {id} = useParams();
	const {data: detailKonsultasi, isLoading: loadingFetcing} = useDetailKonsultasi(id);

	if (loadingFetcing) {
		return (
			<DashboardLayout>
				<FormCard backTitle="Daftar list konsultasi" title="Detail Konsultasi">
					<CircleLoader />
				</FormCard>
			</DashboardLayout>
		);
	}

	return (
		<DashboardLayout>
			<FormCard
				backTitle="Daftar list konsultasi"
				title={`Detail data konsultasi ${detailKonsultasi?.data?.name}`}
				onBackButtonClick={() => history.push("/master-konsultasi")}>
				<div class="row gx-2 mb-5">
					<div class="col-sm-6 col-6">
						<div class="setting-item">
							<label class="setting-label ">Nama konsultasi</label>
							<p className="text-bold text-grey">{detailKonsultasi?.data?.name}</p>
						</div>
					</div>
				</div>

				<div class="text-center my-3">
					<SubmitButton
						className="btn btn-orange d-inline-block mw-250"
						text="Edit this data"
						onClick={() => history.push(`/master-konsultasi/edit/${detailKonsultasi?.data?.id}`)}
					/>
				</div>
			</FormCard>
		</DashboardLayout>
	);
}
